/** Copied from src/client/components/OfferPage/AlwaysOn/AlwaysOnStickyHeader.tsx walled content login & signup buttons */
import { accountAccessShowLogin } from 'actions/UiActions'
import TextButton from 'LuxKit/Button/TextButton'
import BodyText from 'LuxKit/Typography/BodyText'
import { mediaQueryDown, mediaQueryUp } from 'components/utils/breakpoint'
import { useAppDispatch } from 'hooks/reduxHooks'
import { rem } from 'polished'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import styled from 'styled-components'

const InlineWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  & > * + * {
    margin-left: ${rem(8)};
  }

  ${mediaQueryUp.tablet} {
    justify-content: flex-end;
  }
`

const AuthButtonsWrapper = styled.div`
  display: flex;
  align-items: center;

  & > * + * {
    margin-left: ${rem(8)};
  }
`

const MobileNewLine = styled.br`
  ${mediaQueryUp.tablet} {
    display: none;
  }
`
const HideOnMobile = styled.span`
  ${mediaQueryDown.tablet} {
    display: none;
  }
`

export default function GenericLoginSignupWall() {
  const authDispatch = useAppDispatch()

  return (
    <InlineWrapper>
      <BodyText weight="bold" variant="small">
        <FormattedMessage
          id="YO7HwmVobZ"
          defaultMessage="Join now to view {mobileNewLine} member prices"
          description="Heading text encouraging users to join to see member prices"
          values={{ mobileNewLine: <MobileNewLine /> }}
        />
      </BodyText>
      <AuthButtonsWrapper>
        <TextButton kind="secondary" onClick={() => authDispatch(accountAccessShowLogin())}>
          <FormattedMessage
            id="kuZFOMGJO7"
            defaultMessage="Log In"
            description="Button text to log in"
          />
        </TextButton>
        <TextButton kind="primary" onClick={() => authDispatch(accountAccessShowLogin())}>
          <FormattedMessage
            id="STcrnK1Hye"
            defaultMessage="Sign up<forFree> for free</forFree>"
            description="Button text to sign up with optional 'for free' on larger screens"
            values={{ forFree: (chunks: React.ReactNode) => <HideOnMobile>{chunks}</HideOnMobile> }}
          />
        </TextButton>
      </AuthButtonsWrapper>
    </InlineWrapper>
  )
}
